<div class="disclosure-approvals">
  <button type="button" class="disclosure-approvals__back" (click)="goBack()">
    <img src="/public/svgs/arrow-left-g.svg" alt="" width="16" height="16" aria-hidden="true" />
    {{ 'app.identity.disclosure.page.back' | translate }}
  </button>

  <header class="disclosure-approvals__header">
    <div class="disclosure-approvals__header-icon" aria-hidden="true">
      <img src="/public/svgs/lock-g.svg" alt="" width="22" height="22" />
    </div>
    <div class="disclosure-approvals__header-copy">
      <h1 class="disclosure-approvals__title">
        {{ 'app.identity.disclosure.page.title' | translate }}
      </h1>
      <p class="disclosure-approvals__subtitle">
        {{ 'app.identity.disclosure.page.subtitle' | translate }}
      </p>
    </div>
  </header>

  @if (pageError()) {
    <app-info-banner
      class="disclosure-approvals__error"
      [title]="'app.identity.disclosure.page.actionErrorTitle'"
      [message]="pageError()!"
      [ariaLabel]="'app.identity.disclosure.page.actionErrorAria'"
      [translateTitle]="true"
      [translateMessage]="false"
      [translateAriaLabel]="true"
    />
  }

  @if (isLoading()) {
    <div class="disclosure-approvals__loading" aria-busy="true">
      <p>{{ 'app.identity.disclosure.page.loading' | translate }}</p>
    </div>
  } @else if (showLoadError()) {
    <app-parent-empty-state
      [centered]="false"
      titleKey="app.identity.disclosure.page.error"
      subtitleKey="app.identity.disclosure.page.errorHint"
      ariaLabelKey="app.identity.disclosure.page.errorAria"
      iconMask="/public/svgs/refresh.svg"
    >
      <app-parent-button parentEmptyActions variant="ghost" (clicked)="refresh()">
        {{ 'app.identity.disclosure.page.retry' | translate }}
      </app-parent-button>
    </app-parent-empty-state>
  } @else if (pending().length === 0) {
    <app-parent-empty-state
      [centered]="false"
      titleKey="app.identity.disclosure.page.empty"
      subtitleKey="app.identity.disclosure.page.emptyHint"
      ariaLabelKey="app.identity.disclosure.page.emptyAria"
      iconMask="/public/svgs/bell.svg"
    />
  } @else {
    <div class="disclosure-approvals__list">
      @for (request of pending(); track request.id) {
        <article class="disclosure-request-card">
          <header class="disclosure-request-card__header">
            <div>
              <h2 class="disclosure-request-card__title">
                {{
                  kidName(request.subjectUserId) ||
                    ('app.identity.disclosure.request.unknownChild' | translate)
                }}
              </h2>
              <p class="disclosure-request-card__meta">
                {{ 'app.identity.disclosure.request.partner' | translate }}:
                <strong>{{ partnerLabel(request.partnerRef) }}</strong>
              </p>
            </div>
            @if (expiryDate(request); as expires) {
              <p class="disclosure-request-card__expiry">
                {{ 'app.identity.disclosure.request.expires' | translate }}:
                {{ expires | date: 'mediumDate' }}
              </p>
            }
          </header>

          <section class="disclosure-request-card__scopes">
            <span class="disclosure-request-card__scopes-label">
              {{ 'app.identity.disclosure.request.scopes' | translate }}
            </span>
            <ul class="disclosure-request-card__scope-list">
              @for (scopeId of request.scopeIds ?? []; track scopeId) {
                <li>{{ scopeLabel(scopeId) }}</li>
              }
            </ul>
          </section>

          <footer class="disclosure-request-card__actions">
            <app-parent-button
              variant="primary"
              [loading]="isActing(request.id!)"
              [disabled]="isActing(request.id!)"
              (clicked)="approve(request)"
            >
              {{ 'app.identity.disclosure.actions.approve' | translate }}
            </app-parent-button>
            <app-parent-button
              variant="ghost"
              [loading]="isActing(request.id!)"
              [disabled]="isActing(request.id!)"
              (clicked)="deny(request)"
            >
              {{ 'app.identity.disclosure.actions.deny' | translate }}
            </app-parent-button>
          </footer>
        </article>
      }
    </div>
  }
</div>
